import styles from "../../css/dist/index.module.css";
import { JSXElements } from "../../types";

export const BlurTextSetup = ({ children }: { children: JSXElements }) => {
  return (<div className={`${styles["w-min"]} ${styles["relative"]}`}>
    <div className={`${styles["blur-xl"]} ${styles["absolute"]} ${styles["select-none"]}`}>{ children }</div>
    <div>{ children }</div>
  </div>);
};
